/* Namie ATC upgrade offer engine (variant-level).
   On add-to-cart, looks up the selected variant's ordered upsell targets,
   shows the first in-stock one, and swaps to it on accept. 24h cap. */
(function () {
  'use strict';

  var TESTING = false;          // 24h cap active
  var CAP_KEY = 'nm_atc_seen';
  var CAP_MS = 24 * 60 * 60 * 1000;

  var cfgEl = document.querySelector('[data-atc-upsell-config]');
  var overlay = document.querySelector('[data-atc-overlay]');
  if (!cfgEl || !overlay) return;
  var CFG; try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var MAP = (CFG && CFG.bySourceVariant) || {};
  var form = document.querySelector('.js-product-form');
  if (!form) return;

  var resolved = false, lastFocus = null;

  var PUMP = { BR:'Gold', SV:'Silver', CO:'Rose Gold', MB:'Matte Black', BC:'Black & Copper', BP:'Black Plastic', AC:'Aluminium Cap' };
  var TRAY = { ACADTR:2, ACATTR:3, WDTR:2, BDTR:2, WTTR:3, BTTR:3 };
  var BRK = { BDB:2, GDB:2, SDB:2, BTB:3, GTB:3, STB:3 };

  function dec(raw) {
    var s = (raw || '').split('-')[0].toUpperCase();
    if (/^(GB|PB)/.test(s) && s.length === 12) return { holder:'none', count:1, pump:s.slice(6,8) };
    for (var b in BRK) if (s.indexOf(b + 'SET') === 0) return { holder:'bracket', count:BRK[b], pump:s.slice(-4,-2) };
    if (s.indexOf('SET') === 0) {
      var rest = s.slice(3);
      for (var t in TRAY) if (rest.indexOf(t) === 0) return { holder:'tray', count:TRAY[t], pump:s.slice(-2) };
      var contents = rest.slice(3, -4);            // glass(2)+labelColour(1) ... pump(2)+size(2)
      return { holder:'none', count:contents.length, pump:rest.slice(-4,-2) };
    }
    return null;
  }

  function noun(targetSku, sourceSku) {
    // Storage jar sets (JARSET…8/12/16): name the size, e.g. "a set of 12".
    if (/^JARSET/i.test(targetSku || '')) {
      var jm = (targetSku || '').match(/(\d+)\s*$/);
      return jm ? ('a set of ' + jm[1]) : 'a set';
    }
    var t = dec(targetSku), s = sourceSku ? dec(sourceSku) : null;
    if (!t) return 'a set';
    // same holder type = a count climb (e.g. tray double -> tray triple): name the count
    if ((t.holder === 'tray' || t.holder === 'bracket') && s && s.holder === t.holder) {
      var cw = t.count >= 3 ? 'triple' : 'double';
      return 'a ' + cw + ' ' + (t.holder === 'tray' ? 'tray' : 'wall bracket') + ' set';
    }
    if (t.holder === 'tray') return 'a tray set';
    if (t.holder === 'bracket') return 'a wall bracket set';
    return t.count >= 3 ? 'a triple set' : 'a double set';
  }

  function money(cents) {
    var p = Math.round(cents) / 100, s = Math.round(p * 100) / 100;
    return '£' + (Number.isInteger(s) ? s : s.toFixed(2));
  }

  function capActive() {
    if (TESTING) return false;
    try { var t = parseInt(localStorage.getItem(CAP_KEY)||'0',10); return t && (Date.now()-t) < CAP_MS; } catch(e){ return false; }
  }
  function setCap() { if (TESTING) return; try { localStorage.setItem(CAP_KEY, String(Date.now())); } catch(e){} }

  function fillModal(entry, target) {
    var head = noun(target.sku, entry.sku);
    overlay.querySelector('[data-atc-head]').textContent = 'Make it ' + head;
    var img = overlay.querySelector('[data-atc-img]');
    img.src = target.image || ''; img.alt = target.title;

    var src = dec(entry.sku);
    var matchEl = overlay.querySelector('[data-atc-match]');
    if (src && PUMP[src.pump]) {
      var word = src.count > 1 ? 'pumps' : 'pump';
      matchEl.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg> Matched to your ' + PUMP[src.pump] + ' ' + word;
      matchEl.hidden = false;
    } else matchEl.hidden = true;

    var priceEl = overlay.querySelector('[data-atc-price]');
    priceEl.textContent = (target.price > entry.price) ? ('+' + money(target.price - entry.price)) : money(target.price);

    var saveWrap = overlay.querySelector('[data-atc-save]');
    var hasSaving = target.saving && target.saving > 0;
    if (hasSaving) { overlay.querySelector('[data-atc-save-amt]').textContent = money(target.saving); saveWrap.hidden = false; }
    else saveWrap.hidden = true;

    overlay.querySelector('[data-atc-accept]').textContent = 'Make it ' + head + (hasSaving ? (' · save ' + money(target.saving)) : '');
    overlay.querySelector('[data-atc-decline]').textContent = 'No thanks';
    var ab = overlay.querySelector('[data-atc-accept]');
    ab.dataset.variantId = target.id;
    ab.dataset.upsellSku = target.sku;
  }

  function openModal() {
    lastFocus = document.activeElement;
    overlay.hidden = false;
    requestAnimationFrame(function(){ overlay.classList.add('is-open'); });
    document.addEventListener('keydown', onKey, true);
    overlay.addEventListener('mousedown', onBackdrop);
    var b = overlay.querySelector('[data-atc-accept]'); if (b) b.focus();
  }
  function closeModal() {
    overlay.classList.remove('is-open');
    document.removeEventListener('keydown', onKey, true);
    overlay.removeEventListener('mousedown', onBackdrop);
    var done = function(){ overlay.hidden = true; overlay.removeEventListener('transitionend', done); if (lastFocus && lastFocus.focus) lastFocus.focus(); };
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) done();
    else overlay.addEventListener('transitionend', done);
  }
  function onBackdrop(e){ if (e.target === overlay) decline(); }
  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); decline(); return; }
    if (e.key === 'Tab') {
      var f = overlay.querySelectorAll('button'); if (!f.length) return;
      var first = f[0], last = f[f.length-1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function proceed(variantId, upsellSku) {
    resolved = true; setCap();
    var input = form.querySelector('input[name="id"]');
    if (variantId && input) input.value = variantId;
    if (upsellSku) {
      // line-item property -> carries to the order, used to tag the order as an ATC upsell
      var prop = form.querySelector('input[name="properties[_atc_upsell]"]');
      if (!prop) { prop = document.createElement('input'); prop.type = 'hidden'; prop.name = 'properties[_atc_upsell]'; form.appendChild(prop); }
      prop.value = upsellSku;
    }
    closeModal();
    if (form.requestSubmit) form.requestSubmit(); else form.submit();
  }
  function accept(){ var ab = overlay.querySelector('[data-atc-accept]'); proceed(ab.dataset.variantId, ab.dataset.upsellSku); }
  function decline(){ proceed(null, null); }

  overlay.querySelector('[data-atc-accept]').addEventListener('click', accept);
  overlay.querySelector('[data-atc-decline]').addEventListener('click', decline);
  overlay.querySelector('[data-atc-close]').addEventListener('click', decline);

  document.addEventListener('submit', function (e) {
    if (e.target !== form) return;
    if (resolved) return;
    if (capActive()) return;
    var input = form.querySelector('input[name="id"]');
    if (!input) return;
    var entry = MAP[input.value];
    if (!entry || !entry.targets || !entry.targets.length) return;  // no offer -> normal add
    var target = entry.targets[0];                                   // first in-stock (best by popularity)
    e.preventDefault();
    e.stopImmediatePropagation();
    fillModal(entry, target);
    openModal();
  }, true);
})();
